export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/qQvuy7HvYg8Ko3YLoHW66f/expande2.png'

export const BRAND_NAME = 'EXPANDE'
export const BRAND_TAGLINE = 'Tu visión. Tus posibilidades.'
